class ContinuousScrollComponent extends HTMLElement {
  constructor() {
    super();
    this.initScrolling();
  }

  initScrolling() {
    const carousel = this.querySelector('.carousel[data-carousel*="carousel-"]');
    if (carousel) {
      this.duplicateItems(carousel);
      this.setupScrolling(carousel);
    }
  }

  duplicateItems(carousel) {
    const items = Array.from(carousel.children);
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true'); // For accessibility
      carousel.appendChild(clone);
    });
  }

  setupScrolling(carousel) {
    const speed = parseInt(this.dataset.speed, 10) || 1;
    const direction = this.dataset.direction === "left" ? -1 : 1;
    const totalWidth = carousel.scrollWidth;
    let lastTimestamp = 0;

    function animate(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const elapsed = timestamp - lastTimestamp;

      if (elapsed > 16) { 
        carousel.scrollLeft += direction * speed;
        if (carousel.scrollLeft >= totalWidth - carousel.clientWidth) {
          carousel.scrollLeft = 0;
        } else if (carousel.scrollLeft <= 0) {
          carousel.scrollLeft = totalWidth - carousel.clientWidth;
        }
        lastTimestamp = timestamp;
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }
}

customElements.define('continuous-scroll-component', ContinuousScrollComponent);
